export const CHART_COLORS = [
  '#4F7CFF', '#059669', '#dc2626', '#7c3aed', 
  '#ea580c', '#0891b2', '#be185d'
];

export const formatChartValue = (value, isCurrency) => {
  if (typeof value === 'number') {
    if (isCurrency) {
      if (value >= 1000000000) {
        return '$' + (value / 1000000000).toFixed(1) + 'B';
      } else if (value >= 1000000) {
        return '$' + (value / 1000000).toFixed(1) + 'M';
      } else if (value >= 1000) {
        return '$' + (value / 1000).toFixed(1) + 'K';
      }
      return '$' + value.toLocaleString('en-US', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      });
    }
    return value.toLocaleString();
  }
  return value;
};

export const createChartTooltip = (active, payload, isCurrency) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    const value = payload[0].value;
    
    return (
      <div style={{
        backgroundColor: 'white',
        padding: '10px',
        border: '1px solid #e2e8f0',
        borderRadius: '6px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <p style={{ margin: '0 0 5px 0', fontWeight: '600', fontSize: '13px' }}>
          {data.fullCategory || data.fullName || data.category || data.name}
        </p>
        <p style={{ margin: 0, color: '#4F7CFF', fontSize: '14px', fontWeight: '600' }}>
          {isCurrency 
            ? '$' + value.toLocaleString('en-US', { 
                minimumFractionDigits: 2, 
                maximumFractionDigits: 2 
              })
            : value.toLocaleString()
          }
        </p>
      </div>
    );
  }
  return null;
};